/**
 * @typedef DeleteDialogEventOptions
 * @property {string} message
 * @property {string} alertMessage
 * @property {string} confirmText
 * @property {string} onConfirmHandler
 */

class DeleteDialogEvent extends CustomEvent {
  /**
   * Cria um novo evento para Snackbar
   * @param {DeleteDialogEventOptions} options Opções de exibição de Snackbar
   */
  constructor(options) {
    super(DeleteDialogEvent.EVENT, { detail: options });
  }

  /**
   * Exibe uma mensagem em Snackbar
   * @param {DeleteDialogEventOptions} options Opções de exibição de Snackbar
   */
  static emit(options) {
    document.dispatchEvent(new DeleteDialogEvent(options));
  }

  /**
   * Escuta de eventos de emissão de Snackbar
   * @param {Function} handler Função a ser chamada quando escutar um novo evento
   */
  static on(handler) {
    document.addEventListener(DeleteDialogEvent.EVENT, handler);
  }

  /**
   * Remove a escuta de emissão de Snackbar
   * @param {Function} handler Função a ser removida da escuta de eventos
   */
  static off(handler) {
    document.removeEventListener(DeleteDialogEvent.EVENT, handler);
  }
}

DeleteDialogEvent.EVENT = 'app:delete-dialog';

export default DeleteDialogEvent;
